import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';

import RteFile from './RteFileComponent.vue';

export default Node.create({
  name: 'rteFile',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      filesource: {
        default: '',
      },
      filename: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'rte-file',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['rte-file', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(RteFile);
  },
});
